module.exports = __webpack_public_path__ + "images/avatars/male/5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/5.svg
// module id = OdJD
// module chunks = 118